import {
  MenuBills,
  MenuBillsFilled,
  MenuCockpit,
  MenuCockpitFilled,
  MenuMySubscriptions,
  MenuMySubscriptionsFilled,
  MenuPartner,
  MenuPartnerFilled,
  MenuUser,
  MenuUserFilled,
} from "@/assets/icons/icons";
import type { PortalNavigationItem } from "@/components/Layout/PortalShellConfig";
import { useCustomerTribe } from "@/hooks/useCustomerTribe";
import { portalRoutes } from "@/router/routes/portalRoutes";
import { useGetCustomer } from "@/services/api";
import { isFwbEligibleCustomer } from "@/utils/customerUtils";

export const navigationItems: PortalNavigationItem[] = [
  {
    icon: <MenuCockpit />,
    activeIcon: <MenuCockpitFilled />,
    text: "layout.menu.items.cockpit",
    target: portalRoutes.cockpit.base,
  },
  {
    icon: <MenuMySubscriptions />,
    activeIcon: <MenuMySubscriptionsFilled />,
    text: "layout.menu.items.mySubscriptions",
    target: portalRoutes.mySubscriptions.base,
  },
  {
    icon: <MenuBills />,
    activeIcon: <MenuBillsFilled />,
    text: "portal:common.bills",
    ariaLabel: "layout.menu.items.documentsAriaLabel",
    target: portalRoutes.documents.base,
  },
  {
    icon: <MenuPartner />,
    activeIcon: <MenuPartnerFilled />,
    text: "Common.products.friendsWithBenefits",
    bottomNavText: "layout.menu.items.friendsWithBenefitsShort",
    target: portalRoutes.friendsWithBenefits.base,
  },
  {
    icon: <MenuUser />,
    activeIcon: <MenuUserFilled />,
    text: "layout.menu.items.account",
    ariaLabel: "layout.menu.items.accountAriaLabel",
    target: portalRoutes.user.base,
  },
] as const;

type CustomerShellQueryOptions = {
  enabled?: boolean;
};

/** Friends-with-benefits is hidden until the customer is loaded and for business customers. */
export const useVisibleNavigationItems = ({
  enabled = true,
}: CustomerShellQueryOptions = {}) => {
  const { data: customer } = useGetCustomer(undefined, {
    query: { enabled },
  });
  const showFriendsWithBenefits = isFwbEligibleCustomer(customer);

  if (!enabled) {
    return navigationItems;
  }

  return navigationItems.filter(
    (item) =>
      !(
        item.target === portalRoutes.friendsWithBenefits.base &&
        !showFriendsWithBenefits
      ),
  );
};

export const useShowFriendsWithBenefitsAttentionBubble = ({
  enabled = true,
}: CustomerShellQueryOptions = {}) => {
  const { data: customerTribe } = useCustomerTribe({ enabled });

  if (!enabled) {
    return false;
  }

  return !(
    // If data is saved for 'showFriendsWithBenefitsHint' it means user already viewed the friendsWithBenefits page before (during this login-session)
    !!sessionStorage.getItem("showFriendsWithBenefitsHint") ||
    !!customerTribe?.tribeId
  );
};
